export class User {
  id: number;
  email: string;
  name: string;
  pushEndpoint?: string;

  constructor(id: number, email: string, name: string) {
    this.id = id;
    this.email = email;
    this.name = name;
  }
}